module.exports = __webpack_public_path__ + "static/media/accepted_inactive.6f198d1b.svg";